<div class="holiday-management-dialog bg-white rounded-[20px] overflow-hidden">
  <div class="flex items-start justify-between px-6 py-5">
    <div class="flex flex-col gap-1">
      <h2 class="text-2xl font-semibold text-primary-dark">Gerenciamento de Feriados</h2>
      <p class="text-primary-gray">Organize e mantenha o calendário de feriados</p>
    </div>

    <div class="flex items-center gap-3">
      <button
        type="button"
        class="rounded-lg bg-primary text-white px-4 py-2.5 text-base font-medium flex items-center gap-2 hover:opacity-95"
        (click)="openNewHoliday()"
      >
        <mat-icon>add</mat-icon>
        <span>Novo Feriado</span>
      </button>

      <button
        type="button"
        class="w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 transition-colors"
        aria-label="Fechar"
        (click)="close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="border-t border-gray-200 px-6 py-5 flex flex-col gap-3">
    <div class="flex items-center justify-between gap-4 flex-wrap">
      <div class="flex items-center gap-3 flex-wrap">
        <p class="text-base font-semibold text-primary-dark">Tipo de Feriado:</p>
        <label *ngFor="let type of holidayTypes" class="flex items-center gap-2 text-base text-primary-dark">
          <input type="checkbox" class="w-4 h-4" [checked]="isTypeChecked(type)" (change)="toggleType(type)" />
          <span>{{ type }}</span>
        </label>
      </div>

      <div class="flex items-center gap-2">
        <label class="text-base font-semibold text-primary-dark" for="orderBy">Ordenar por:</label>
        <select
          id="orderBy"
          class="h-10 rounded-lg border border-gray-300 px-3 py-2 min-w-[180px]"
          [ngModel]="selectedOrderBy"
          (ngModelChange)="onOrderByChange($event)"
        >
          <option *ngFor="let option of orderByOptions" [ngValue]="option.value">{{ option.label }}</option>
        </select>
      </div>
    </div>

    <div class="flex gap-3 flex-wrap sm:flex-nowrap">
      <ng-select
        class="holiday-filter-select w-full"
        [items]="statesOptions"
        [multiple]="true"
        [closeOnSelect]="false"
        [searchable]="true"
        [clearable]="true"
        [loading]="isLoadingOptions"
        placeholder="Selecione o(s) Estado(s)"
        [ngModel]="selectedStates"
        (ngModelChange)="onStatesChange($event)"
      >
      </ng-select>

      <ng-select
        class="holiday-filter-select w-full"
        [items]="municipalitiesOptions"
        [multiple]="true"
        bindLabel="name"
        bindValue="ibgeCode"
        [closeOnSelect]="false"
        [searchable]="true"
        [clearable]="true"
        [loading]="isLoadingOptions"
        [disabled]="selectedStates.length === 0"
        placeholder="Selecione o(s) Município(s)"
        [ngModel]="selectedCityIbgeCodes"
        (ngModelChange)="onMunicipalitiesChange($event)"
      >
      </ng-select>
    </div>

    <div class="relative">
      <mat-icon class="absolute left-3 top-2.5 text-gray-400">search</mat-icon>
      <input
        type="text"
        class="w-full h-10 pl-10 pr-3 border border-gray-300 rounded-lg input-field-focus"
        placeholder="Buscar feriados..."
        [formControl]="searchControl"
      />
    </div>
  </div>

  <div class="px-6 pb-4">
    <div class="holiday-table-wrapper border border-gray-100 rounded-lg overflow-hidden">
      <table class="w-full">
        <thead>
          <tr class="bg-primary-table-gray text-primary-gray text-sm">
            <th class="py-3 px-4 text-left font-semibold">Data</th>
            <th class="py-3 px-4 text-left font-semibold">Tipo</th>
            <th class="py-3 px-4 text-left font-semibold">Estado</th>
            <th class="py-3 px-4 text-left font-semibold">Município</th>
            <th class="py-3 px-4 text-left font-semibold">Motivo</th>
            <th class="py-3 px-4 text-left font-semibold">Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="isLoadingList">
            <td colspan="6" class="py-12 px-4 text-center text-primary-gray">Carregando feriados...</td>
          </tr>

          <tr *ngIf="!isLoadingList && !hasResults">
            <td colspan="6" class="py-12 px-4 text-center text-primary-gray">
              Nenhum feriado foi encontrado para os critérios selecionados.
            </td>
          </tr>

          <tr *ngFor="let holiday of holidays" class="border-b border-gray-200 last:border-b-0">
            <td class="py-3.5 px-4 text-primary-dark">{{ formatDate(holiday.date) }}</td>
            <td class="py-3.5 px-4">
              <span class="holiday-type-badge" [ngClass]="typeBadgeClass(holiday.type)">
                {{ holiday.type }}
              </span>
            </td>
            <td class="py-3.5 px-4 text-primary-dark">{{ holiday.state || '-' }}</td>
            <td class="py-3.5 px-4 text-primary-dark">{{ holiday.municipality || '-' }}</td>
            <td class="py-3.5 px-4 text-primary-dark">{{ holiday.reason }}</td>
            <td class="py-3.5 px-4">
              <div class="flex items-center gap-1">
                <button type="button" class="action-icon-btn" aria-label="Editar feriado" (click)="openEditHoliday(holiday.id)">
                  <span class="material-symbols-outlined small-icon text-gray-600">edit_square</span>
                </button>
                <button type="button" class="action-icon-btn" aria-label="Excluir feriado" (click)="deleteHoliday(holiday)">
                  <mat-icon class="small-icon text-gray-600">close</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="border-t border-gray-200 px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
    <p class="text-primary-gray text-base">Mostrando {{ startIndex }} a {{ endIndex }} de {{ totalCount }} resultados</p>

    <div class="flex items-center gap-2">
      <button
        type="button"
        class="pager-btn"
        aria-label="Página anterior"
        [disabled]="page <= 1"
        (click)="goToPage(page - 1)"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <button
        type="button"
        *ngFor="let pageNumber of pageNumbers"
        class="pager-btn"
        [class.active]="pageNumber === page"
        (click)="goToPage(pageNumber)"
      >
        {{ pageNumber }}
      </button>

      <button
        type="button"
        class="pager-btn"
        aria-label="Próxima página"
        [disabled]="page >= totalPages"
        (click)="goToPage(page + 1)"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
